var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 200,
    viewBox: "0 0 146 200",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M71.978 0.171728C28.0446 -2.49265 1.92506 26.2942 0.141166 55.3852C-2.43151 97.3393 30.8324 108.811 45.0638 129.594C68.644 164.031 30.6175 175.702 32.9922 189.953C35.3669 204.204 61.6874 201.233 79.894 193.713C104.56 183.525 142.576 136.511 87.0182 108.815C38.1933 84.4761 29.0451 66.2406 25.1321 55.3852C18.9973 38.366 26.5078 12.1614 59.6154 12.1614C83.0602 12.1614 89.393 30.6456 83.8518 44.3006C79.675 54.5936 74.4468 70.6587 83.0602 81.3096C90.5804 90.6086 102.256 95.9321 115.911 94.1708C133.128 91.9499 140.453 81.2024 143.617 70.621C152.846 39.7513 115.911 2.8361 71.978 0.171728Z",
    fill: "#ffffff"
  })));
};

export default __webpack_public_path__ + "static/media/silvy_white_icon.38b07551.svg";
export { SvgComponent as ReactComponent };